import React from 'react';
import { Link } from 'react-router-dom';

import { hockeyFormatter } from '@nhl/formatter-utilities';

import { TeamDisplay } from '@nhl/nhl-react-ui/lib/TeamDisplay';

import gameStateTypes from '../../../../utils/gameStateTypes';
import gameScheduleTypes from '../../../../utils/gameScheduleTypes';

const getGameInfo = game => (
    <div className="game-info" key={'game-info' + game.id}>
        <div className={`team away-team ${game.state.id >= gameStateTypes.SOFT_FINAL && game.visitingScore < game.homeScore ? 'defeated' : ''}`}>
            <TeamDisplay
                team={game.visitingTeam}
                season={game.season.id}
                displayTricode={true}
                background={'dark'}
            />
            {game.state.id >= gameStateTypes.LIVE &&
                <div className="team-score">{game.visitingScore}</div>
            }
        </div>

        <div className={`team home-team ${game.state.id >= gameStateTypes.SOFT_FINAL && game.homeScore < game.visitingScore ? 'defeated' : ''}`}>
            <TeamDisplay
                team={game.homeTeam}
                season={game.season.id}
                displayTricode={true}
                background={'dark'}
            />
            {game.state.id >= gameStateTypes.LIVE &&
                <div className="team-score">{game.homeScore}</div>
            }
        </div>
    </div>
);

const getGameState = game => {
    const gameTimeParts = hockeyFormatter.displayGameTime(game, true).split(' ');

    return (
        <div className="game-state" key={'game-state' + game.id}>
            {game.state.id === gameStateTypes.FUTURE ?
                gameTimeParts.join(' ')
            :
                <>
                    {gameTimeParts.shift()}
                    {gameTimeParts.length >= 1 &&
                    <>
                        <br/>
                        {gameTimeParts.join(' ')}
                    </>
                    }
                </>
            }
        </div>
    );
};

const getGameDisplayInner = game => [getGameInfo(game), getGameState(game)];

const sendGaClickEvent = game => {
    window.dataLayer.push({
        event: 'click',
        'event_category': 'Header Scoreboard',
        'event_label': `game ${game.id}`
    });
};

const areEqual = ({ game }) => {
    const { state } = game;
    return state.id < gameStateTypes.PREGAME || state.id >= gameStateTypes.OFFICIAL;
};

const HSBGameDisplay = ({ game, isAccountApp }) => {
    return (
        game.state.id >= gameStateTypes.PREGAME && game.gameScheduleState.id === gameScheduleTypes.SCHEDULED ?
            isAccountApp ?
                <a href={`/games/${game.id}`} onClick={(e) => {
                    sendGaClickEvent(game)
                }} className={`hsb-game-display game-${game.id} link`}>{getGameDisplayInner(game)}</a>
                :
                <Link to={`/games/${game.id}`} onClick={sendGaClickEvent.bind(this, game)}
                      className={`hsb-game-display game-${game.id} link`}>{getGameDisplayInner(game)}</Link>
            :
            <span className={`hsb-game-display game-${game.id}`}>{getGameDisplayInner(game)}</span>
    );
};

export default React.memo(HSBGameDisplay, areEqual);
